import { ProductConditionSummary, VariantGroup } from 'src/types';

export enum FilterEnum {
  PRICES_INC_SHIPPING = 'showPricesInclShipping',
  PICKUP_ONLY = 'showPickupOnly',
  INTERNATIONAL = 'showInternational',
  UNAVAILABLE = 'showUnavailable',
}

export interface IOfferlistFilters {
  visible?: boolean;
  closeHandler?: () => void;
  variantGroups?: VariantGroup[] | null;
  conditions: ProductConditionSummary[];
  categoryId: string | undefined;
}
